import { useDispatch, useSelector } from "react-redux"
import Api from "../../Api"
import faceImage8 from "../../assets/images/faces/face8.jpg"
import logoMini from '../../assets/images/logo-mini.svg'
import logo from '../../assets/images/logo.svg'
import { selectUserInfo, setIsLoggedIn } from "../../redux/User"
import { useLocation, useNavigate } from "react-router-dom"


const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const api = Api();

  const { userInfo } = useSelector((store: any) => ({
    userInfo: selectUserInfo(store),
  }));

  const logout = ()=>{
    api.user.logout();
    dispatch(setIsLoggedIn(true));
    navigate(location.state?.from?.pathname || "/login", {
      replace: true,
    });
  }
  return (

    <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <div className="me-3">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-bs-toggle="minimize">
            <span className="icon-menu"></span>
          </button>
        </div>
        <div>
          <a className="navbar-brand brand-logo" href="#">
            <img src={logo} alt="logo" />
          </a>
          <a className="navbar-brand brand-logo-mini" href="#">
            <img src={logoMini} alt="logo" />
          </a>
        </div>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-top">
        <ul className="navbar-nav">
          <li className="nav-item font-weight-semibold d-none d-lg-block ms-0">
            <h1 className="welcome-text">Good Morning, <span className="text-black fw-bold">{userInfo.fullName}</span></h1>
            {/* <h3 className="welcome-sub-text">Your performance summary this week </h3> */}
          </li>
        </ul>
        <ul className="navbar-nav ms-auto">
          <li className="nav-item dropdown d-none d-lg-block user-dropdown">
            <a className="nav-link" id="UserDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
              <img className="img-xs rounded-circle" src={faceImage8} alt="Profile image" /> </a>
            <div className="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown">
              <div className="dropdown-header text-center">
                <img className="img-md rounded-circle" src={faceImage8} alt="Profile image" />
                <p className="mb-1 mt-3 font-weight-semibold">{userInfo.fullName}</p>
                <p className="fw-light text-muted mb-0">{userInfo.username}</p>
              </div>
              {/* <a className="dropdown-item"><i className="dropdown-item-icon mdi mdi-account-outline text-primary me-2"></i> My
                Profile</a> */}
              <a className="dropdown-item" onClick={()=>logout()}><i className="dropdown-item-icon mdi mdi-power text-primary me-2"></i>Sign Out</a>
            </div>
          </li>
        </ul>
        <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
          data-bs-toggle="offcanvas">
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
  );
};

export default Header;